class ispCustomSortBy{
    constructor(currentSort) {
        this.currentSort = currentSort;
        this.sortOptions =  {
            "relevency": {
                name: "Best Match",
                id: "isp_sort_best_match",
                sort_value: "relevency"
            },
            "max to mix": {
                name: "Price: High to Low",
                id: "isp_sort_price_high_to_low",
                sort_value: "price_max_to_min"
            },
            "min to max": {
                name: "Price: Low to High",
                id: "isp_sort_price_low_to_high",
                sort_value: "price_min_to_max"
            },
            // "newest": {
            //     name: "Newest",
            //     id: "isp_sort_newest_arrival",
            //     sort_value: "creation_date"
            // },
            // "oldest": {
            //     name: "Oldest",
            //     id: "creation_date_oldest",
            //     sort_value: "creation_date_oldest"
            // },
            "reviews": {
                name: "Customer Rating",
                id: "isp_sort_reviews",
                sort_value: "reviews"
            }
        };
    }

    appendToFilters(){
        if(document.getElementById("facet_group_sort")) return;

        let retHtml = '<div id="facet_group_sort" class="mobile_facet_group open_group_container">';
        retHtml += `<header onclick="slideBar.toggleFacetGroup(this)" class="facet_header open_group" data-position="2">
                        <span class="isp_facet_group_title_text">Sort By<span>
                        <span class="facet_group_toggle_button open"></span>
                    </span></span></header>`;

        for (const key in this.sortOptions){
            const {name, id, sort_value} = this.sortOptions[key];
            const selected = this.currentSort === sort_value ? " selected_facet_isp" : "";
            retHtml += `<div id="${id}" class="isp_single_mobile_facet not_collapsed ignore_facet ${selected}" sort_value="${sort_value}">${name}</div>`
        }

        retHtml += '</div>';

        $("#mobile_facet_container").prepend(retHtml);
        this.addEventListeners();
    }

    addEventListeners(){
        $(".isp_single_mobile_facet[sort_value]").click(function (event) {
            if(!this.classList.contains("selected_facet_isp")){
                $(".selected_facet_isp[sort_value]").removeClass("selected_facet_isp");
                $(this).addClass("selected_facet_isp");
                ispHandleSortingChoice(event,this);
            }
        });
    }
}